export default "__VITE_ASSET__DnfkFPfm__"